import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { renderFinalPrice } from "helpers/utils";

import QuantityInput from "../quantityInput/QuantityInput";
import Tooltip from "./tooltip/Tooltip";

import {
    ItemStyled,
    Image,
    Title,
    Info,
    ImageContainer,
    QuanityContainer,
    Price,
    PriceContainerMobile,
    PriceContainerDesktop
} from "./Product.styled";

function Product({ name, item, index, mobile, slider }) {
    const { register } = useFormContext();
    const prefix = mobile ? "m" : "d";
    const showTooltip =
        item?.images?.length > 0 || (item?.title && item?.shortDescription);
    const price = renderFinalPrice(item?.price ?? 0);
    const image =
        item?.images?.length > 0
            ? item?.images[0]
            : item?.thumbnail ?? {
                  url: "https://picsum.photos/150/150",
                  alt: "placeholder image"
              };

    return (
        <ItemStyled slider={slider}>
            <ImageContainer slider={slider}>
                {image && (
                    <Image src={image?.url} alt={image?.alt} loading="lazy" />
                )}
            </ImageContainer>
            <Info slider={slider}>
                <Title slider={slider}>{item?.title}</Title>
                <PriceContainerMobile slider={slider}>
                    <Price>
                        {showTooltip && <Tooltip item={item} />}
                        {price}
                    </Price>
                </PriceContainerMobile>
                <QuanityContainer slider={slider}>
                    <QuantityInput
                        slider={slider}
                        id={`${prefix}-quantity-${item.id}`}
                        name={`${name}[${index}].quantity`}
                    />
                </QuanityContainer>
            </Info>
            <PriceContainerDesktop slider={slider}>
                <Price slider={slider}>
                    {showTooltip && <Tooltip item={item} />}
                    {price}
                </Price>
            </PriceContainerDesktop>
            <input
                id={`${prefix}-price-${item.id}`}
                name={`${name}[${index}].price`}
                defaultValue={item?.variants?.edges?.[0]?.price}
                ref={register}
                hidden
            />
            <input
                id={`${prefix}-sku-${item.id}`}
                name={`${name}[${index}].sku`}
                defaultValue={item?.variants?.edges?.[0]?.sku}
                ref={register}
                hidden
            />
            <input
                id={`${prefix}-id-${item.id}`}
                name={`${name}[${index}].id`}
                defaultValue={item?.id}
                ref={register}
                hidden
            />
        </ItemStyled>
    );
}

Product.defaultProps = {
    slider: false,
    mobile: undefined,
    item: {
        id: undefined,
        title: undefined,
        sku: undefined,
        price: 0,
        shortDescription: undefined
    }
};

Product.propTypes = {
    slider: PropTypes.bool,
    mobile: PropTypes.bool,
    name: PropTypes.string.isRequired,
    item: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        sku: PropTypes.string,
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        variants: PropTypes.shape({
            edges: PropTypes.arrayOf(
                PropTypes.shape({
                    sku: PropTypes.string,
                    price: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.number
                    ])
                })
            )
        }),
        shortDescription: PropTypes.string,
        thumbnail: PropTypes.shape({
            url: PropTypes.string,
            alt: PropTypes.string
        }),
        images: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string,
                alt: PropTypes.string
            })
        )
    }),
    index: PropTypes.number.isRequired
};

export default Product;
